// The visitor's accent colour: applied as <html data-accent="..."> and
// remembered on their device. Storage can be unavailable (private mode), so
// every access is guarded and the choice then simply lasts for the visit.
import { accents, DEFAULT_ACCENT } from '../data/accents';

export const ACCENT_STORAGE_KEY = 'accent';

export const isAccent = (id) => accents.some((accent) => accent.id === id);

export const currentAccent = () => {
    const value = document.documentElement.getAttribute('data-accent');
    return isAccent(value) ? value : DEFAULT_ACCENT;
};

// Applies and remembers an accent. Returns false for an unknown id.
export function setAccent(id) {
    if (!isAccent(id)) return false;
    const root = document.documentElement;
    if (id === DEFAULT_ACCENT) root.removeAttribute('data-accent');
    else root.setAttribute('data-accent', id);
    try {
        if (id === DEFAULT_ACCENT) window.localStorage.removeItem(ACCENT_STORAGE_KEY);
        else window.localStorage.setItem(ACCENT_STORAGE_KEY, id);
    } catch (e) { /* storage unavailable: not remembered */ }
    return true;
}

// Looks an accent up by id or label, case-insensitively ("Ocean", "ocean").
export const findAccent = (name) => {
    const wanted = String(name || '').trim().toLowerCase();
    return accents.find((accent) => accent.id === wanted || accent.label.toLowerCase() === wanted) || null;
};
